export default __webpack_public_path__ + "static/media/Lianel-Artiles-Dev-CV-Esp.ff07c8db.pdf";